export default {
	'activate.GetTheVerificationCode': '获取验证码',
	'activate.Resend': '重新发送',
	'activate.PleaseEnterYourPhoneNumber': '请输入手机号',
	'activate.PleaseEnterTheCorrectMobilePhoneNumber': '请输入正确的手机号',
	'activate.please': '请',
	'activate.sResendAfterThat': 's之后再重新发送',
	'activate.FailedToGetVerificationCode': '获取验证码失败',
	'activate.TheVerificationCodeIsNotLegitimate': '验证码不合法',
	'activate.TheVerificationCodeIsIncorrect': '验证码错误',
	'activate.ThePhoneNumberThatReceivesTheActivationCode': '接收激活码的手机号',
	'activate.VerificationCode': '验证码',
	'activate.EnquireNow': '立即查询',
	'activate.TheActivationCodeIsAProductRedemptionVoucherObtainedFromAThirdPartyAndCanBeRedeemedForTheCorrespondingProduct':
		'激活码是从第三方获取的商品兑换凭证，可兑换相应的商品'
};
